/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPreferenceGetSetSettings } from '../../models/user-preference-get-set-settings';

export interface UserPreferenceSettingGetUserPreferenceSettings$Params {
  id?: number;
  practiceId?: string | null;
}

export function userPreferenceSettingGetUserPreferenceSettings(http: HttpClient, rootUrl: string, params?: UserPreferenceSettingGetUserPreferenceSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPreferenceGetSetSettings>> {
  const rb = new RequestBuilder(rootUrl, userPreferenceSettingGetUserPreferenceSettings.PATH, 'get');
  if (params) {
   
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPreferenceGetSetSettings>;
    })
  );
}

userPreferenceSettingGetUserPreferenceSettings.PATH = '/api/UserPreferenceSetting/getuserpreferencesetting';
